import React, { Fragment } from 'react';
import { Entry, ProgramInformation, StyledProgram } from './ProgramEntry.styles';
import { times } from '../../../../../play-core/utils/times';
import { InfoContainer } from '../../../pages/Show/ShowInfo/ShowInfo.styles';
import { TextPlaceholder } from '../../Placeholder/TextPlaceholder';
import { AspectPlaceholder } from '../../Teaser/Placeholder/AspectPlaceholder';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ProgramEntryListPlaceholder = ({
  placeholderChannelCount
}) => /*#__PURE__*/_jsx(Fragment, {
  children: times(placeholderChannelCount, index => /*#__PURE__*/_jsx(StyledProgram, {
    children: /*#__PURE__*/_jsxs(Entry, {
      showFirstColumn: true,
      children: [/*#__PURE__*/_jsx(AspectPlaceholder, {
        aspectRatio: 3 / 2
      }), /*#__PURE__*/_jsx(ProgramInformation, {
        children: /*#__PURE__*/_jsxs(InfoContainer, {
          children: [/*#__PURE__*/_jsx(TextPlaceholder, {
            width: 90
          }), /*#__PURE__*/_jsx(TextPlaceholder, {
            width: 94
          }), /*#__PURE__*/_jsx(TextPlaceholder, {
            width: 92
          }), /*#__PURE__*/_jsx(TextPlaceholder, {
            width: 76
          })]
        })
      })]
    })
  }, index))
});